export default {
    "types": {
        "1": {
            "showName": "Создана"
        },
        "100": {
            "showName": "В работе"
        },
        "200": {
            "showName": "Завершена"
        }
    }
}